const isIRC = (organizationName?: string) => (
  organizationName?.toLowerCase() === "international rescue committee"
);

export default isIRC;
